export const PARTNER_AGENT_BRANCH_REQUEST = "PARTNER_AGENT_BRANCH_REQUEST";
export const PARTNER_AGENT_BRANCH_SUCCESS = "PARTNER_AGENT_BRANCH_SUCCESS";
export const PARTNER_AGENT_BRANCH_FAILURE = "PARTNER_AGENT_BRANCH_FAILURE";

export const APPROVE_DISAPPROVE_AGENT_REQUEST =
  "APPROVE_DISAPPROVE_AGENT_REQUEST";
export const APPROVE_DISAPPROVE_AGENT_SUCCESS =
  "APPROVE_DISAPPROVE_AGENT_SUCCESS";
export const APPROVE_DISAPPROVE_AGENT_FAILURE =
  "APPROVE_DISAPPROVE_AGENT_FAILURE";
